import { ODataTextLine } from '../odata-types/multiline-text.type';
import { LoadStatus } from '../load-status';
import { NotificationIdState } from '../utilities/notification-id.type';

/**
 * Feature key under which the escalation slice is registered in the root store.
 */
export const ESCALATION_FEATURE_KEY = 'escalation';

/**
 * Serializable record of a notification that has an active escalation timer.
 * The `setTimeout` handle is a plain number and is serializable, so the full entry
 * lives in the store — the service holds no in-memory state of its own.
 * Entries are persisted to IndexedDB but intentionally never rehydrated on boot:
 * a handle from a previous session is invalid, and `checkEscalationRequired` will
 * re-schedule timers from scratch.
 */
export type EscalationTimer = Readonly<{
    notificationId: NotificationIdState;
    timerHandle: number;
}>;

export type EscalationCollectionState = Readonly<{
    timerEntries: EscalationTimer[];
    status: LoadStatus;
}>;

export const initialEscalationCollectionState: EscalationCollectionState = {
    timerEntries: [],
    status: LoadStatus.Idle,
};

export type OdataEscalation = Readonly<{
    MessageType: string;
    Date: string;
    Time: string;
    EscalationLtextSet: ODataTextLine[];
    FrontId: string;
    NotificationNo: string;
    TaskNumber: string;
    TimeZone: string;
    UTCSign: string;
    UTCDiff: string;
}>;
